/**
 * ================================================================
 * Bisou Rivage — bisou-mockup.js
 * ================================================================
 * Bouton « En savoir plus » dans la rangée d'achat (#bisou-mockup-btn).
 * Clic → dans la colonne d'achat elle-même, les boutons s'effacent et
 * une carte a sommaire prend leur place — Œuvre, Artiste, Nos tirages et
 * ses six fiches, toujours visibles a gauche, le contenu a droite —,
 * calée en absolu sur .bisou-s1-wrapper : ni fixed, ni calque, comme le
 * panneau « édition limitée ». Mobile : même DOM dans le flux, et un rail
 * natif de cartes portrait sous le pouce. Panier et retour sous la carte.
 * ================================================================
 */
(function () {
  'use strict';

  /* Pont i18n : les libellés viennent de sections/bisou-mockup.liquid, le JS n'a pas
     accès au filtre | t. Chaque appel garde son repli français. */
  var I18N = {};
  try { I18N = JSON.parse((document.getElementById('bisou-mockup-i18n') || {}).textContent || '{}'); } catch (e) {}
  function t(key, fallback) {
    var v = I18N[key];
    return (typeof v === 'string' && v) ? v : fallback;
  }
  function tfill(key, fallback, vars) {
    var s = t(key, fallback);
    for (var k in vars) {
      if (Object.prototype.hasOwnProperty.call(vars, k)) s = s.split('{' + k + '}').join(vars[k]);
    }
    return s;
  }

  var A_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h16M14 6l6 6-6 6"/></svg>';
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  function init() {
    var section = document.querySelector('.bisou-mockup-section');
    var anchor = document.getElementById('bisou-mockup-btn');
    var mount = document.getElementById('bisou-mockup-mount');
    if (!section || !anchor || !mount || anchor.dataset.built) return;
    var srcs = Array.prototype.slice.call(section.querySelectorAll('.bm-src'));
    if (!srcs.length) return;
    anchor.dataset.built = '1';

    var num = function (s) { return s.getAttribute('data-num'); };
    var title = function (s) { return s.getAttribute('data-title'); };
    var media = function (s) { return s.querySelector('.bm-src-media'); };
    var body = function (s) { return s.querySelector('.bm-src-body'); };

    /* Une fiche est « horizontale » ou « verticale » selon l'image qu'elle
       porte (largeur vs hauteur des attributs HTML, deja poses par le Liquid
       — pas besoin d'attendre le chargement). Le schema des dimensions (SVG)
       garde sa mise en page a lui, jamais celle-ci. */
    function orientationDeMedia(zone) {
      if (!zone || zone.querySelector('svg.bm-dimsvg')) return null;
      var img = zone.querySelector('img');
      if (img) {
        var w = parseInt(img.getAttribute('width'), 10);
        var h = parseInt(img.getAttribute('height'), 10);
        if (w && h) return w >= h ? 'h' : 'v';
      }
      if (zone.querySelector('video')) return 'h';
      return null;
    }

    var mq = window.matchMedia('(min-width: 900px)');
    var mode = null;
    /* L'ouvreur du volet courant. Le volet est reconstruit a chaque bascule
       de palier ; les declencheurs cables une seule fois (« + d'infos »)
       passent par cette reference pour ne jamais viser un volet retire. */
    var ouvrirCourant = null;

    /* ═══════════ DIMENSIONS ADAPTATIVES ═══════════
       Le volet « Dimensions » (corps contenant un <table> A4/A3/A2) est transformé :
       faux-cadre orienté (H/V selon le produit) + couleurs distinctes par élément,
       et tableau réduit au SEUL format choisi par le client + lien « voir plus ». */
    var DIM_COLORS = { 'Cadre': '#2f2a24', 'Papier': '#9a948a', 'Image': '#6e8aa6', 'Ouv. PP': '#b8985e' };
    var DIM_ORDER = ['Cadre', 'Papier', 'Ouv. PP', 'Image'];
    var DIM_LABEL = { 'Cadre': 'Cadre', 'Papier': 'Papier', 'Ouv. PP': 'Passe-partout', 'Image': 'Image' };
    var dimData = null;

    function parseDimPair(s) { if (!s) return null; var m = String(s).match(/(\d+)\D+(\d+)/); return m ? [+m[1], +m[2]] : null; }

    function parseDimTable(table) {
      var head = table.querySelectorAll('thead th, thead td');
      var fmts = [];
      for (var i = 1; i < head.length; i++) fmts.push(head[i].textContent.trim().toUpperCase());
      var data = {};
      Array.prototype.forEach.call(table.querySelectorAll('tbody tr'), function (tr) {
        var cells = tr.querySelectorAll('td, th'); if (cells.length < 2) return;
        var measure = cells[0].textContent.trim();
        for (var j = 1; j < cells.length; j++) { var f = fmts[j - 1]; if (!f) continue; (data[f] || (data[f] = {}))[measure] = cells[j].textContent.trim(); }
      });
      return Object.keys(data).length ? data : null;
    }

    function productOrient() { var a = document.getElementById('rv5-bloc-associated'); return (a && a.dataset.orientation) === 'horizontal' ? 'horizontal' : 'vertical'; }
    function selectedFmt() { var r = document.querySelector('.rv5-format-row.active'); var f = r && (r.getAttribute('data-f') || '').toUpperCase(); return (f === 'A2' || f === 'A3' || f === 'A4') ? f : null; }

    /* Couleur du cadre selon la finition choisie (lit le libellé couleur de la fiche). */
    function frameColor() {
      var el = document.getElementById('rv5-color-label');
      /* Meme piege que le chronometre de resize : une variable « t » ici
         masquerait le helper i18n t() pour toute la fonction. */
      var label = (el ? el.textContent : '').toLowerCase();
      if (/noir|black/.test(label)) return '#2b2724';
      if (/blanc|white/.test(label)) return '#d6d2ca';
      if (/ch.?ne|oak/.test(label)) return '#b8895a';
      if (/bouleau|birch/.test(label)) return '#d8c39c';
      if (/sans|none|papier|paper/.test(label)) return '#cfcabe';
      return '#2f2a24';
    }

    /* Schéma annoté : CADRE CENTRÉ, chaque élément étiqueté par une ligne de rappel fine
       + pastille colorée. Pointillés aérés. La couleur du cadre suit la finition choisie. */
    function dimSvg(dRaw, orient) {
      function P(k, fb) { var p = parseDimPair(dRaw && dRaw[k]); p = p || fb; return orient === 'horizontal' ? [p[1], p[0]] : p; }
      var cad = P('Cadre', [500, 700]);
      var pap = P('Papier', [Math.round(cad[0] * 0.84), Math.round(cad[1] * 0.85)]);
      var ouv = P('Ouv. PP', [Math.round(cad[0] * 0.78), Math.round(cad[1] * 0.83)]);
      var img = P('Image', [Math.round(cad[0] * 0.74), Math.round(cad[1] * 0.8)]);
      var fw = cad[0], fh = cad[1];
      var pad = 20, side = Math.max(220, Math.round(fw * 0.52));
      /* La reserve de droite porte les legendes ; a GAUCHE il n'y a rien a
         mettre. Elle y etait quand meme : un quart de la boite vide, donc un
         dessin reduit d'autant a largeur egale — c'est de la que venait le
         « illisible » du 29/08. */
      var marge = 24;
      var vbW = marge + fw + side, vbH = pad + fh + pad;
      var cx = marge + fw / 2, cy = vbH / 2;
      var fcol = frameColor();
      function rect(d, fill, stroke, sw, dash) { var x = (cx - d[0] / 2).toFixed(1), y = (cy - d[1] / 2).toFixed(1); return '<rect x="' + x + '" y="' + y + '" width="' + d[0] + '" height="' + d[1] + '" rx="4" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + sw + '"' + (dash ? ' stroke-dasharray="' + dash + '"' : '') + '/>'; }
      var s = '<svg class="bm-dimsvg" viewBox="0 0 ' + Math.round(vbW) + ' ' + Math.round(vbH) + '" role="img" aria-label="' + t('anatomy_aria', 'Anatomie du tirage encadré') + '">';
      s += rect(cad, '#f4efe6', fcol, 14);
      s += rect(pap, '#ffffff', '#9a948a', 2, '18 13');
      s += rect(ouv, 'none', '#b8985e', 2.5);
      s += rect(img, '#cfdae4', '#6e8aa6', 2.5);
      var labelX = cx + cad[0] / 2 + 24;
      var items = [['Cadre', cad[0], fcol], ['Papier', pap[0], DIM_COLORS['Papier']], ['Ouv. PP', ouv[0], DIM_COLORS['Ouv. PP']], ['Image', img[0], DIM_COLORS['Image']]];
      var rows = [0.15, 0.38, 0.62, 0.85];
      items.forEach(function (it, i) {
        var col = it[2], ry = cy - fh / 2 + fh * rows[i], sx = cx + it[1] / 2;
        s += '<line x1="' + sx.toFixed(1) + '" y1="' + ry.toFixed(1) + '" x2="' + (labelX - 9) + '" y2="' + ry.toFixed(1) + '" stroke="#d3ccbe" stroke-width="1.3"/>';
        s += '<circle cx="' + sx.toFixed(1) + '" cy="' + ry.toFixed(1) + '" r="4.5" fill="' + col + '"/>';
        s += '<text x="' + labelX + '" y="' + (ry + 9).toFixed(1) + '" font-family="Space Mono, monospace" font-size="33" fill="' + col + '">' + DIM_LABEL[it[0]] + '</text>';
      });
      s += '</svg>';
      return s;
    }

    function dimFmtButtons(active) {
      if (!dimData) return '';
      var html = '<div class="bm-dimfmts">';
      ['A4', 'A3', 'A2'].forEach(function (f) { if (!dimData[f]) return; html += '<button type="button" class="bm-dimfmt' + (f === active ? ' on' : '') + '" data-f="' + f + '">' + f + '</button>'; });
      return html + '</div>';
    }

    function dimTable(fmt, dRaw) {
      var html = '<table class="bm-dimtable"><tbody><tr class="bm-dimtable-h"><td colspan="2">Format ' + fmt + '</td></tr>';
      DIM_ORDER.forEach(function (k) {
        var v = dRaw && dRaw[k]; if (!v) return;
        if (!/mm/i.test(v)) v += ' mm';
        var col = (k === 'Cadre') ? frameColor() : DIM_COLORS[k];
        html += '<tr><td><span class="bm-dimdot" style="background:' + col + '"></span><span style="color:' + col + '">' + DIM_LABEL[k] + '</span></td><td>' + v + '</td></tr>';
      });
      html += '</tbody></table>';
      return html;
    }

    function renderDimPanel(media, body) {
      var fmt = (body && body.getAttribute('data-dim-fmt')) || selectedFmt() || 'A2';
      var orient = productOrient();
      var dRaw = dimData && dimData[fmt];
      if (media) media.innerHTML = '<div class="bm-dimcap">' + tfill('anatomy_caption_html', 'Anatomie d\'un tirage encadré — exemple {fmt}', { fmt: fmt }) + '</div>' + dimSvg(dRaw, orient);
      if (body) {
        var intro = body.getAttribute('data-dim-intro') || '';
        body.innerHTML = intro + dimTable(fmt, dRaw) + '<a class="bm-dimmore" href="/pages/formats-dimensions">' + t('see_all_formats', 'Voir tous les formats →') + '</a>';
      }
    }

    function enhanceDims(scope) {
      if (!scope || !scope.querySelectorAll) return;
      Array.prototype.forEach.call(scope.querySelectorAll('.bm-src-body'), function (body) {
        if (body.dataset.dimDone) return;
        var table = body.querySelector('table'); if (!table) return;
        if (!dimData) dimData = parseDimTable(table);
        if (!dimData) return;
        body.dataset.dimDone = '1';
        var intro = body.querySelector('p'); body.setAttribute('data-dim-intro', intro ? intro.outerHTML : '');
        var media = body.parentNode && body.parentNode.querySelector('.bm-src-media');
        if (media) media.classList.add('bm-dim-media');
        body.classList.add('bm-dim-body');
        renderDimPanel(media, body);
      });
    }

    function refreshDims() {
      Array.prototype.forEach.call(document.querySelectorAll('.bm-dim-body'), function (body) {
        body.removeAttribute('data-dim-fmt');
        renderDimPanel(body.parentNode && body.parentNode.querySelector('.bm-dim-media'), body);
      });
    }
    document.addEventListener('bisou:variant-change', refreshDims);
    /* clic sur un bouton format dans un panneau dimensions → aperçu local (sans toucher au panier) */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.bm-dimfmt');
      if (!b) return;
      var body = b.closest('.bm-dim-body'); if (!body) return;
      body.setAttribute('data-dim-fmt', b.getAttribute('data-f'));
      renderDimPanel(body.parentNode && body.parentNode.querySelector('.bm-dim-media'), body);
    });

    /* Desktop only: one short wheel gesture advances exactly one product block.
       Targets are based on stable block wrappers; inner content can finish
       rendering without changing the order or making a block unreachable. */
    function installDesktopMagneticScroll() {
      try {
        if (new URLSearchParams(window.location.search).get('product_scroll') === 'free') {
          document.documentElement.classList.add('bisou-product-scroll-free');
        }
      } catch (e) {}
      if (document.documentElement.classList.contains('bisou-product-scroll-free')) return;
      if (window.__bisouProductMagneticScroll) return;
      window.__bisouProductMagneticScroll = true;

      /* ── Machine d'état simple ──
         Zone SLIDES (bloc 1 « la fiche », bloc 2 « Associez le ») : la molette
         est entièrement contrôlée, un geste = un bloc. Zone LIBRE (sous le bloc
         2) : scroll naturel ; en remontant, le premier geste RECALE fermement le
         bloc 2, le geste suivant remonte à la fiche. */

      /* `?product_scroll=debug` affiche les nombres du calage en bas a gauche.
         Meme famille que `?product_scroll=free` juste au-dessus : un parametre
         d'URL, rien de visible sans lui. */
      var DEBUG = false;
      try { DEBUG = new URLSearchParams(window.location.search).get('product_scroll') === 'debug'; } catch (e) {}
      var debugBox = null;
      function debug(txt) {
        if (!DEBUG) return;
        if (!debugBox) {
          debugBox = document.createElement('pre');
          debugBox.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:9999;margin:0;padding:8px 10px;background:rgba(0,0,0,.85);color:#4ade80;font:11px/1.55 monospace;white-space:pre;pointer-events:none;border-radius:5px';
          document.body.appendChild(debugBox);
        }
        debugBox.textContent = txt;
      }

      var acc = 0;
      var accDir = 0;
      var accTimer = null;
      var locked = false;
      var lockTimer = null;
      var animating = false;
      var animationId = 0;
      var dotsRoot = null;

      /* ═══ L'INERTIE DU TRACKPAD (Max, 27/08 : « sur mac ça a tendance à aller
         encore plus loin ») ═══
         Une molette de souris envoie des crans espacés ; un trackpad envoie une
         traînée qui continue près d'une seconde après que les doigts ont quitté
         la surface. Un verrou à durée fixe expirait au milieu de cette traînée,
         et ce qu'il en restait suffisait à déclencher le bloc suivant : un
         geste, deux blocs.

         Le verrou ne compte donc plus le temps écoulé mais le SILENCE. Il ne se
         lève qu'après REPOS millisecondes sans un seul événement, et chaque
         événement avalé pendant le verrou repousse l'échéance. Le plancher passé
         à `lock()` laisse d'abord l'animation finir ; PLAFOND garantit qu'une
         molette tournée sans relâche finit toujours par reprendre la main. */
      var REPOS = 140;
      var PLAFOND = 1600;
      var lockFloor = 0;
      var lockHard = 0;

      function planifierDeverrouillage() {
        clearTimeout(lockTimer);
        var maintenant = performance.now();
        var reste = Math.max(REPOS, lockFloor - maintenant);
        reste = Math.min(reste, Math.max(0, lockHard - maintenant));
        lockTimer = setTimeout(function () {
          locked = false;
          acc = 0;
          accDir = 0;
        }, reste);
      }

      function lock(ms) {
        locked = true;
        var maintenant = performance.now();
        lockFloor = maintenant + ms;
        lockHard = maintenant + Math.max(ms, PLAFOND);
        planifierDeverrouillage();
      }

      function absoluteTop(el) {
        var rect = el.getBoundingClientRect();
        return window.scrollY + rect.top;
      }

      /* ── LES DEUX BLOCS ──
         Il y en avait trois tant que le mockup occupait son propre écran. Depuis
         la pile de cartes (26/08), `#bisou-mockup-mount` reste vide sur
         ordinateur : le volet carte postale ne le remplit plus du tout. Le bloc du milieu mesurait donc zéro, la liste n'atteignait jamais
         trois, et TOUT le mécanisme se désarmait en silence — plus de calage,
         plus de points, sans la moindre erreur en console. On ne compte plus que
         ce qui existe : la fiche, puis « Associez le ». */
      function slides() {
        var first = document.querySelector('.bisou-s1-wrapper');
        var second = document.getElementById('rv5-bloc-associated');
        var secondGrid = second && second.querySelector('.rv5-associated-grid');
        if (!first || !second) return [];
        if (!first.offsetParent || !second.offsetParent) return [];
        if (second.getBoundingClientRect().height < 20) return [];

        var vh = window.innerHeight;

        /* Le centre du tirage, mesuré DANS LA FENÊTRE, colonne collée.
           La colonne image est `sticky top:0, height:100vh` : une fois passé le
           premier écran, sa position dans la fenêtre ne bouge plus. L'écart
           entre son bord haut et le centre du tirage, lui, ne dépend jamais du
           défilement — on peut donc le lire à n'importe quel moment et s'en
           servir de cible.

           ── On mesure l'IMAGE, plus le cadre (Max, 28/08) ──
           `.rv5-media-frame` est le conteneur de la galerie : il porte aussi la
           liste des diapos et la rangée de boutons sous les images. Son centre
           tombe donc SOUS celui du tirage, et les vignettes d'« Associez le »
           arrivaient une vingtaine de pixels trop bas. « un tout petit
           décalage », mesuré a 20 px sur sa capture.

           On prend donc la plus grande image du cadre. Les diapos vivent côte à
           côte sur une même rangée : laquelle est active ne change rien à la
           hauteur, qui est la seule chose qu'on lise ici. Sans image mesurable
           — pas encore chargée — on retombe sur le cadre, qui vaut mieux que
           rien le temps que `recalerBientot` repasse au chargement. */
        function centreDuCadre() {
          var frame = document.querySelector('.rv5-media-frame');
          var col = document.querySelector('.product__media-wrapper');
          if (!frame || !col) return null;
          var cr = col.getBoundingClientRect();
          if (cr.height < 20) return null;

          var meilleure = null, aire = 0;
          Array.prototype.forEach.call(frame.querySelectorAll('img'), function (img) {
            var r = img.getBoundingClientRect();
            if (r.width < 40 || r.height < 40) return;
            var a = r.width * r.height;
            if (a > aire) { aire = a; meilleure = r; }
          });

          var fr = meilleure || frame.getBoundingClientRect();
          if (fr.height < 20) return null;
          return (fr.top - cr.top) + fr.height / 2;
        }

        /* Bloc 2 : le centre des vignettes se pose sur le centre du tirage
           (Max, 27/08 : « les images d'Associez le alignées avec le centre du
           mockup »). Jusqu'ici c'était le HAUT du titre sur le HAUT du cadre —
           une autre ligne d'horizon, et les images tombaient plus bas.

           L'ancre est la vignette elle-même, pas le bloc : le bloc porte aussi
           son titre au-dessus et le bouton mur en dessous, et centrer sur lui
           ferait flotter les images sous la ligne du tirage. Sans vignette
           mesurable — grille pas encore remplie, cadre pas encore chargé — on
           retombe sur un centrage fenêtre, qui vaut toujours mieux que rien. */
        function assocY(section) {
          var ancre = section.querySelector('.rv5-assoc-card-img') || secondGrid;
          if (!ancre || ancre.getBoundingClientRect().height < 20) ancre = section;
          var h = ancre.getBoundingClientRect().height;
          var centre = centreDuCadre();
          if (centre === null) return Math.max(0, Math.round(absoluteTop(ancre) + h / 2 - vh / 2));
          return Math.max(0, Math.round(absoluteTop(ancre) + h / 2 - centre));
        }

        /* Bloc 1 : le HAUT DE LA PAGE, pas le centre du bloc.
           On centrait le bloc dans la fenetre, ce qui posait la cible a une
           quarantaine de pixels — la moitie du header — et laissait le header
           coupe en deux. Max, 28/08 : « scroll du haut doit bien aller jusqu'a
           afficher le header ». Zero, donc : un geste vers le haut depuis
           « Associez le » ramene la page a son sommet, header compris. C'est
           aussi ce qui oblige la barre d'annonce a s'effacer sur une fenetre
           basse — voir la regle `max-height` dans bisou-mockup.css. */
        return [
          { el: first, y: 0 },
          { el: second, visualEl: secondGrid || second, y: assocY(second) }
        ];
      }

      /* ═══ LA SORTIE DU PRODUIT (Max, 28/08) ═══
         « Après Associez le, quand le client veut descendre, le scroll est un
         peu long. » Sous le bloc 2 il y a la reserve, puis la fin de la grille
         produit, puis la section suivante — l'artiste. A la molette c'est une
         traversee de vide avant que quelque chose n'arrive.

         Une cible de plus, donc : le haut de la premiere section qui suit le
         produit. Un geste depuis « Associez le » et on est dehors.

         Elle ne se pose pas au ras du haut de la fenetre : Max, une heure
         apres l'avoir eue, « l'aide est un peu trop, diminue un peu ». La
         section suivante arrive donc au quart de la hauteur — le geste
         parcourt trois quarts d'ecran au lieu d'un entier, et la fin du
         produit reste visible au-dessus, comme une transition plutot qu'une
         coupe. SORTIE_HAUT est la part de fenetre laissee au-dessus. Elle ne vaut QUE vers le bas — en remontant depuis
         l'artiste, le geste ramene directement a « Associez le », c'est le
         chemin inverse que Max demande — et elle ne compte pas parmi les
         points : ce n'est pas un bloc du produit, c'est sa porte.

         On cherche la section par le DOM et non par son nom : le gabarit peut
         changer d'ordre dans l'editeur, et `.bisou-mockup-section`, qui suit
         immediatement le produit, est un porte-donnees masque — on saute ce
         qui ne mesure rien. */
      var SORTIE_HAUT = 0.25;
      function sortie(list) {
        var bloc = document.getElementById('rv5-bloc-associated');
        var section = bloc && bloc.closest('.shopify-section');
        var suivante = section && section.nextElementSibling;
        while (suivante && suivante.offsetHeight < 20) suivante = suivante.nextElementSibling;
        if (!suivante) return null;
        var maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        var y = Math.round(absoluteTop(suivante) - window.innerHeight * SORTIE_HAUT);
        if (y <= list[1].y + 40) return null;
        return Math.min(y, maxScroll);
      }

      /* ═══ LA RÉSERVE SOUS « ASSOCIEZ LE » ═══
         Le document doit descendre assez pour que le bloc atteigne le centre,
         et la colonne image doit rester collée jusque-là. Les deux tiennent à
         la même chose : le bas de la grille produit doit tomber à
         `cible + 100vh`. Une colonne collante de 100vh décolle exactement là.

         ── Pourquoi ce n'est plus un `<div>` (Max, 28/08) ──
         Ça l'était, et ça n'a jamais rien fait. `assets/base.css` porte, très
         loin de tout ceci, la règle d'hygiène `div:empty { display: none }`.
         Une cale est un div vide par définition : elle était créée, on lui
         posait sa hauteur, et le navigateur ne l'affichait pas. `offsetHeight`
         renvoyait zéro, le code se croyait à jour, et le trou restait. C'est ce
         que l'encart de diagnostic a fini par dire mot pour mot :
         « reserve 192 (posee 0) ».

         La réserve est donc devenue le `padding-bottom` du bloc lui-même. Rien
         de vide à afficher, aucune règle globale à contourner, un nœud de moins
         dans la page. Le style en ligne l'emporte sur le `padding-bottom: 0`
         de la feuille, qui n'est pas en `!important`.

         Si la hauteur voulue est négative, le bloc déborde déjà l'écran : on ne
         peut pas raccourcir du contenu, on retombe à zéro. */
      /* ═══ LE DECOLLAGE EST PILOTE, PLUS SUBI ═══
         Deux tentatives ont essaye de faire coincider le decollage naturel de
         la colonne collante avec le point de calage, en dimensionnant la
         reserve : la premiere deduisait la geometrie de la zone de grille, la
         seconde la mesurait. Les deux ont laisse l'ecart en place — « Associez
         le » montait seul pendant que le tirage restait cloue.

         On arrete de negocier. Passe le point de calage, on decale le `top` de
         la colonne d'autant que le defilement : elle remonte donc exactement a
         la vitesse de la page. Rien a deduire, rien a mesurer, aucune hypothese
         sur la grille. Un `sticky` a `top: -N` se pose a N pixels au-dessus du
         bord haut de la fenetre, et le seul garde-fou du navigateur — ne jamais
         remonter plus haut que la position naturelle — joue dans notre sens.

         `setProperty(..., 'important')` parce que la feuille de style pose
         `top: 0 !important` sur cette colonne : un style en ligne ordinaire
         perdrait le duel de specificite et ne ferait rien du tout.

         La reserve garde son autre role, celui qu'elle remplit bien : empecher
         le decollage TROP TOT, avant que le bloc ait fini d'arriver au centre.
         Elle ne s'occupe plus du trop tard, qui est desormais impossible. */
      var topPose = null;
      function suivreDecollage(cible) {
        var col = document.querySelector('.product__media-wrapper');
        if (!col) return;
        var delta = Math.round(window.scrollY - cible);
        var valeur = (mq.matches && delta > 0) ? (-delta) + 'px' : '';
        if (valeur === topPose) return;
        topPose = valeur;
        if (valeur) col.style.setProperty('top', valeur, 'important');
        else col.style.removeProperty('top');
      }

      function relacherColonne() {
        var col = document.querySelector('.product__media-wrapper');
        if (col) col.style.removeProperty('top');
        topPose = null;
      }

      function blocAssocie() { return document.getElementById('rv5-bloc-associated'); }

      function reservePosee() {
        var bloc = blocAssocie();
        if (!bloc) return 0;
        return Math.round(parseFloat(bloc.style.paddingBottom) || 0);
      }

      function viderReserve() {
        var bloc = blocAssocie();
        if (bloc) bloc.style.paddingBottom = '';
      }

      function ensureCenteringRoom(list) {
        var col = document.querySelector('.product__media-wrapper');
        var grille = col && col.closest('.product');
        var bloc = blocAssocie();
        if (!grille || !bloc) return;

        var vh = window.innerHeight;
        var actuelle = reservePosee();
        var basNaturel = absoluteTop(grille) + grille.getBoundingClientRect().height - actuelle;
        var voulue = Math.max(0, Math.min(Math.round(list[1].y + vh - basNaturel), Math.round(vh)));

        var ancre = list[1].el.querySelector('.rv5-assoc-card-img');
        /* Le meme choix d'ancre que centreDuCadre : sinon l'encart afficherait
           un nombre que le calage n'utilise pas, et mentirait poliment. */
        var cadre = null, aireCadre = 0;
        var frameDebug = document.querySelector('.rv5-media-frame');
        if (frameDebug) {
          Array.prototype.forEach.call(frameDebug.querySelectorAll('img'), function (img) {
            var r = img.getBoundingClientRect();
            if (r.width < 40 || r.height < 40) return;
            var a = r.width * r.height;
            if (a > aireCadre) { aireCadre = a; cadre = img; }
          });
          if (!cadre) cadre = frameDebug;
        }
        var ecart = Math.round(window.scrollY - list[1].y);
        debug([
          (Math.abs(ecart) < 3 ? '>>> AU CALAGE <<<' : 'ecart cible  ' + (ecart > 0 ? '+' : '') + ecart),
          '',
          'vh           ' + vh,
          'scrollY      ' + Math.round(window.scrollY),
          'cible        ' + list[1].y,
          'sortie       ' + (function () { var p = sortie(list); return p === null ? 'aucune' : p; })(),
          'scroll max   ' + Math.round(document.documentElement.scrollHeight - vh),
          'bas grille   ' + Math.round(basNaturel),
          'reserve      ' + voulue + '  (posee ' + actuelle + ')',
          'top pose     ' + (topPose || '0 (collee)'),
          'col.top      ' + Math.round(col.getBoundingClientRect().top),
          'tirage centre' + (cadre ? Math.round(cadre.getBoundingClientRect().top + cadre.getBoundingClientRect().height / 2) : '?'),
          'vignette c.  ' + (ancre ? Math.round(ancre.getBoundingClientRect().top + ancre.getBoundingClientRect().height / 2) : 'absente')
        ].join(String.fromCharCode(10)));

        if (voulue === actuelle) return;
        bloc.style.paddingBottom = voulue + 'px';
      }

      function visualBottom(slide) {
        var el = slide.visualEl || slide.el;
        return absoluteTop(el) + el.getBoundingClientRect().height;
      }

      function ensureDots(list) {
        if (dotsRoot || list.length !== 2) return;
        dotsRoot = document.createElement('nav');
        dotsRoot.className = 'bmx-slide-dots';
        dotsRoot.setAttribute('aria-label', 'Navigation de la fiche produit');
        list.forEach(function (_, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bmx-slide-dot';
          dot.setAttribute('aria-label', 'Afficher le bloc ' + (index + 1));
          dot.addEventListener('click', function () {
            var currentList = slides();
            if (!currentList[index]) return;
            lock(550);
            animateTo(currentList[index].y, function () {
              var l = slides();
              return l[index] ? l[index].y : null;
            });
          });
          dotsRoot.appendChild(dot);
        });
        document.body.appendChild(dotsRoot);
      }

      function updateDots(list) {
        ensureDots(list);
        ensureCenteringRoom(list);
        if (!dotsRoot) return;
        var current = window.scrollY;
        var dernier = list[list.length - 1].el;
        var basDernier = absoluteTop(dernier) + dernier.getBoundingClientRect().height;
        var porte = sortie(list);
        var borne = porte === null ? basDernier : porte - 14;
        var inProductSlides = current >= list[0].y - 60 && current < borne;
        dotsRoot.classList.toggle('is-visible', inProductSlides);
        dotsRoot.setAttribute('aria-hidden', inProductSlides ? 'false' : 'true');
        var active = 0;
        var distance = Infinity;
        list.forEach(function (slide, index) {
          var d = Math.abs(slide.y - current);
          if (d < distance) { distance = d; active = index; }
        });
        Array.prototype.forEach.call(dotsRoot.children, function (dot, index) {
          dot.classList.toggle('is-active', index === active);
          dot.setAttribute('aria-current', index === active ? 'step' : 'false');
        });
      }

      function canScrollInside(target, direction) {
        var node = target && target.nodeType === 1 ? target : null;
        while (node && node !== document.body) {
          var style = getComputedStyle(node);
          var overflow = style.overflowY;
          var scrollable = (overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight + 2;
          if (scrollable) {
            if (direction > 0 && node.scrollTop < node.scrollHeight - node.clientHeight - 2) return true;
            if (direction < 0 && node.scrollTop > 2) return true;
          }
          node = node.parentElement;
        }
        return false;
      }

      /* `recalculer`, facultatif : rend la cible telle qu'elle est MAINTENANT.
         Une fois posee, l'animation attend un instant et regarde si la cible a
         bouge sous elle — une vignette qui finit de charger, une reserve qui
         se recale — et rattrape l'ecart, mais seulement si le visiteur n'a pas
         touche a la page entre-temps. C'est ce qui rend le calage exact sur les
         ecrans ou la mise en page se stabilise apres coup. */
      function animateTo(targetY, recalculer) {
        animationId += 1;
        var id = animationId;
        var from = window.scrollY;
        var distance = targetY - from;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var duration = reduceMotion ? 0 : Math.min(560, Math.max(380, Math.abs(distance) * 0.4));
        var started = performance.now();
        animating = true;

        /* Si la trame ne revient jamais — onglet mis en arriere-plan en pleine
           course — `animating` resterait vrai et la molette serait morte. */
        setTimeout(function () { if (id === animationId) animating = false; }, duration + 400);

        function poser() {
          animating = false;
          if (typeof recalculer !== 'function') return;
          setTimeout(function () {
            if (id !== animationId) return;
            if (Math.abs(window.scrollY - targetY) > 2) return;
            var neuf = recalculer();
            if (typeof neuf !== 'number' || Math.abs(neuf - targetY) < 4) return;
            window.scrollTo(0, neuf);
          }, 220);
        }

        function frame(now) {
          if (id !== animationId) return;
          var progress = duration ? Math.min(1, (now - started) / duration) : 1;
          var eased = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
          window.scrollTo(0, from + distance * eased);
          if (progress < 1) {
            requestAnimationFrame(frame);
          } else {
            poser();
          }
        }
        requestAnimationFrame(frame);
      }

      window.__bisouAnimateTo = animateTo;

      window.addEventListener('wheel', function (event) {
        if (!mq.matches || event.ctrlKey || document.documentElement.classList.contains('bisou-product-scroll-free')) return;

        var direction = event.deltaY > 0 ? 1 : event.deltaY < 0 ? -1 : 0;
        if (!direction || canScrollInside(event.target, direction)) return;

        var list = slides();
        if (list.length !== 2) return;
        updateDots(list);

        var current = window.scrollY;
        var vh = window.innerHeight;
        var first = list[0].y;
        var last = list[1].y;

        var exit = sortie(list);

        /* ── L'INERTIE, D'ABORD ──
           Le verrou qui suit un calage avale TOUT, quelle que soit la zone.
           Avant, un geste vers le bas pose sur « Associez le » etait libere
           des l'arrivee — et la trainee du trackpad emportait la page au-dela.
           Le verrou ne tient que 140 ms apres le dernier evenement, 1,6 s au
           plus : un visiteur qui repart apres une pause n'attend jamais. */
        if (locked || animating) { event.preventDefault(); planifierDeverrouillage(); return; }

        /* ── OU VA-T-ON ? — decide AVANT d'avaler quoi que ce soit ──
           C'etait la faille du petit ecran (Max, 28/08 : « j'arrive pas a
           scroller en bas, pourtant en inspecteur ca marche »). L'ancien code
           faisait preventDefault PUIS cherchait une destination ; quand il n'en
           trouvait pas — la page posee un peu au-dessus de sa cible, le bloc
           le plus proche etant deja le dernier — il avait deja tue le geste.
           Chaque coup de molette mourait dans le vide. En inspecteur la fenetre
           passait sous 900 px et tout ceci se desactivait : « ca marche ».

           Maintenant : pas de destination, pas de preventDefault. Le
           defilement naturel est toujours la sortie de secours. */
        var destination = null;
        var recalcul = null;
        function cibleBloc2() { var l = slides(); return l.length === 2 ? l[1].y : null; }
        function cibleSortie() { var l = slides(); return l.length === 2 ? sortie(l) : null; }

        if (direction > 0) {
          if (current < last - 14) { destination = last; recalcul = cibleBloc2; }
          else if (exit !== null && current < exit - 14) { destination = exit; recalcul = cibleSortie; }
        } else {
          /* En remontant, la porte ne compte pas : depuis l'artiste on revient
             droit sur « Associez le ». Le plafond garde le comportement d'avant
             — plus bas que ca, le visiteur lit la suite et on le laisse. */
          var plafond = (exit !== null ? exit : visualBottom(list[1])) + vh * 0.35;
          if (current > last + 14 && current <= plafond) { destination = last; recalcul = cibleBloc2; }
          else if (current <= last + 14 && current > first + 14) { destination = first; recalcul = function () { return 0; }; }
        }
        if (destination === null) return;

        event.preventDefault();

        if (accDir !== direction) { acc = 0; accDir = direction; }
        acc += Math.abs(event.deltaY) * (event.deltaMode === 1 ? 16 : 1);
        clearTimeout(accTimer);
        accTimer = setTimeout(function () { acc = 0; }, 160);
        if (acc < 50) return;
        acc = 0;

        lock(550);
        animateTo(destination, recalcul);
      }, { passive: false });

      window.addEventListener('scroll', function () {
        if (!mq.matches) return;
        var list = slides();
        if (list.length !== 2) return;
        suivreDecollage(list[1].y);
        updateDots(list);
      }, { passive: true });

      mq.addEventListener('change', function () {
        if (!mq.matches) {
          if (dotsRoot) dotsRoot.classList.remove('is-visible');
        }
      });

      setTimeout(function () {
        if (!mq.matches) return;
        var list = slides();
        if (list.length === 2) {
          /* Une page rouverte peut arriver deja defilee sous le bloc, sans
             qu'aucun evenement de defilement ne se produise : la colonne
             partirait collee alors qu'elle devrait etre remontee. */
          suivreDecollage(list[1].y);
          updateDots(list);
        }
      }, 350);

      /* ═══ QUAND RECALCULER LA RÉSERVE ═══
         Le bloc se remplit toujours APRÈS coup — c'est le JS qui monte ses
         vignettes. Une réserve calculée une fois pour toutes serait celle d'un
         bloc qui n'existait pas encore. On recalcule donc quand le bloc bouge
         vraiment : à chaque changement de la grille, à chaque changement de sa
         taille, au chargement, au redimensionnement.

         Et quand le calage n'a plus lieu d'être — liste incomplète, mode
         téléphone — la réserve s'efface au lieu de garder sa dernière valeur. */
      function recalerReserve() {
        if (!mq.matches) { relacherColonne(); viderReserve(); return; }
        var list = slides();
        if (list.length !== 2) { viderReserve(); return; }
        ensureCenteringRoom(list);
        updateDots(list);
      }

      var minuteurReserve = null;
      function recalerBientot() {
        clearTimeout(minuteurReserve);
        minuteurReserve = setTimeout(recalerReserve, 120);
      }

      var bloc2 = document.getElementById('rv5-bloc-associated');
      var grille = bloc2 && bloc2.querySelector('.rv5-associated-grid');
      if (grille) {
        new MutationObserver(recalerBientot).observe(grille, { childList: true, subtree: true });
        if (typeof ResizeObserver === 'function') {
          /* Le bloc, pas la reserve : la reserve est sa voisine, jamais son
             enfant, donc la redimensionner ne peut pas relancer l'observateur. */
          new ResizeObserver(recalerBientot).observe(bloc2);
        }
      }
      window.addEventListener('load', recalerBientot);
      mq.addEventListener('change', function () { relacherColonne(); recalerBientot(); });
      window.addEventListener('resize', recalerBientot, { passive: true });
    }

    function wireCarousels(scope) {
      scope.querySelectorAll('.bm-media--carousel').forEach(function (m) {
        if (m.dataset.wired) return; m.dataset.wired = '1';
        var sl = m.querySelectorAll('.bm-slide'), dt = m.querySelectorAll('.bm-dot'), i = 0;
        function go(n) { i = (n + sl.length) % sl.length; sl.forEach(function (s, k) { s.classList.toggle('on', k === i); }); dt.forEach(function (d, k) { d.classList.toggle('on', k === i); }); }
        m.querySelectorAll('.bm-arr').forEach(function (a) { a.addEventListener('click', function (e) { e.stopPropagation(); go(i + parseInt(a.getAttribute('data-dir'), 10)); }); });
        dt.forEach(function (d) { d.addEventListener('click', function (e) { e.stopPropagation(); go(parseInt(d.getAttribute('data-k'), 10)); }); });
        sl.forEach(function (s, k) { s.classList.toggle('on', k === 0); }); dt.forEach(function (d, k) { d.classList.toggle('on', k === 0); });
      });
      scope.querySelectorAll('.bm-media:not(.bm-media--carousel) .bm-slide').forEach(function (s) { s.classList.add('on'); });
    }

    /* ═══════════ LA CARTE POSTALE — quatrieme forme (28/08, tard) ═══════════

       Ce que le client doit comprendre, voir et atteindre depuis « En savoir
       plus », dans les mots de Max : trois chapitres.
         1. L'OEUVRE — le cartel : du texte et des variables.
         2. L'ARTISTE — portrait, bio, signature, ses tirages.
         3. NOS TIRAGES — ce qui vaut pour tous : imprime sur une machine de
            fou, signe a la main et embosse, certificat papier a puce NFC,
            encadre a la main par nos soins, puis les dimensions et la
            livraison.

       LA CARTE A SOMMAIRE. Le feuillet du soir etait « trop grand » (il
       s'elargissait avec l'ecran) et « on devait deviner » : trois mots en
       tete ne disent pas ce qu'on va trouver. Cette fois la carte fait la
       largeur de la colonne d'achat, jamais plus — 600 px, comme l'ecran
       qu'elle remplace —, et porte SON SOMMAIRE A GAUCHE, toujours visible :
       Oeuvre, Artiste, puis Nos tirages et ses six lignes. On lit tout ce
       qu'il y a d'un coup d'oeil, on clique, le contenu vient a droite :
       l'image en haut, le texte dessous. Rien a deviner, rien a defiler.

       LE BLOC, PAS UN CALQUE. Meme principe que le panneau « edition
       limitee » : le module est cale en absolu sur .bisou-s1-wrapper, la
       colonne d'achat ; ses boutons s'effacent en cascade et la carte prend
       leur place. Rien de fixed, rien qui recouvre l'oeuvre ou l'en-tete.

       MOBILE (< 900 px). Le sommaire se replie en trois chapitres sur une
       ligne et la carte devient un rail natif — l'idiome du carrousel
       « Associez le » : une carte portrait a 76 %, centree, ses voisines
       qui depassent, scroll-snap, plein cadre par marges sous 750 px. */
    var ORDRE_FICHES = ['impression', 'signature', 'certificat', 'encadrement', 'dimension', 'livraison'];

    function etiquettePile(slot) {
      return t('stack_' + slot, slot.charAt(0).toUpperCase() + slot.slice(1));
    }

    /* Le module courant : reconstruit a chaque bascule de palier, et
       DETRUIT proprement avant — ses ecouteurs sur document/window y compris. */
    var cartelSync = null;
    var moduleCourant = null;

    function buildPostale() {
      var artistSrc = section.querySelector('.bm-artist-src');
      var tirageSrc = section.querySelector('.bm-tirage-src');
      var deuxChiffres = function (n) { return n < 10 ? '0' + n : String(n); };

      var parSlot = {};
      srcs.forEach(function (s) {
        var slot = (s.getAttribute('data-slot') || '').trim();
        if (slot && !parSlot[slot]) parSlot[slot] = s;
      });

      /* ── Les cartes, dans l'ordre de lecture, chacune sous son chapitre ── */
      var defs = [{ id: 'oeuvre', chap: 0, label: t('stack_oeuvre', 'Œuvre') }];
      if (artistSrc && artistSrc.innerHTML.trim()) defs.push({ id: 'artiste', chap: 1, label: t('tab_artist', 'Artiste') });
      var fiches = [];
      ORDRE_FICHES.forEach(function (slot) {
        if (parSlot[slot]) fiches.push({ id: slot, chap: 2, label: etiquettePile(slot), src: parSlot[slot] });
      });
      fiches.forEach(function (f, j) { f.rang = j; });
      defs = defs.concat(fiches);

      var CHAPITRES = [
        { id: 0, label: t('stack_oeuvre', 'Œuvre') },
        { id: 1, label: t('tab_artist', 'Artiste') },
        { id: 2, label: t('stack_prints', 'Nos tirages') }
      ].filter(function (c) { return defs.some(function (d) { return d.chap === c.id; }); });

      var colonne = document.querySelector('.bisou-s1-wrapper');

      var pile = document.createElement('div');
      pile.className = 'bmk';
      pile.setAttribute('hidden', '');
      pile.setAttribute('role', 'region');
      pile.setAttribute('aria-label', t('stack_open', 'En savoir plus'));

      var inner = document.createElement('div');
      inner.className = 'bmk__inner';

      /* ── La tete : les chapitres (telephone), les fleches, fermer ── */
      var tete = document.createElement('div');
      tete.className = 'bmk__head';
      var chapNav = document.createElement('div');
      chapNav.className = 'bmk__chapters';
      var chapBtns = [];
      CHAPITRES.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bmk__chapter';
        b.textContent = c.label;
        b.addEventListener('click', function () { aller(premierIndex(c.id)); });
        chapNav.appendChild(b); chapBtns.push(b);
      });
      var outils = document.createElement('div');
      outils.className = 'bmk__tools';
      var fleches = document.createElement('div');
      fleches.className = 'bmk__arrows';
      var prec = document.createElement('button');
      prec.type = 'button'; prec.className = 'bmk__arrow';
      prec.setAttribute('aria-label', t('stack_prev', 'Volet precedent'));
      prec.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12H4M10 6l-6 6 6 6"/></svg>';
      var suiv = document.createElement('button');
      suiv.type = 'button'; suiv.className = 'bmk__arrow';
      suiv.setAttribute('aria-label', t('stack_next', 'Volet suivant'));
      suiv.innerHTML = A_R;
      fleches.appendChild(prec); fleches.appendChild(suiv);
      /* Les fleches sont la suite de l'index, pas une barre d'outils : elles
         se rangent sous ses lignes (voir le CSS, palier ordinateur). Sur
         telephone l'index n'existe pas et elles etaient deja masquees. */
      var fermer = document.createElement('button');
      fermer.type = 'button'; fermer.className = 'bmk__x';
      fermer.setAttribute('aria-label', t('stack_close', 'Fermer'));
      fermer.innerHTML = '<span>' + t('stack_close', 'Fermer') + '</span>' + X;
      outils.appendChild(fermer);
      tete.appendChild(chapNav); tete.appendChild(outils);

      /* ── La carte : le sommaire a gauche, le contenu a droite ── */
      var stage = document.createElement('div');
      stage.className = 'bmk__stage';

      var sommaire = document.createElement('nav');
      sommaire.className = 'bmk__index';
      sommaire.setAttribute('aria-label', t('stack_open', 'En savoir plus'));
      /* L'index porte son nom : « En savoir plus ». On ouvrait une carte sans
         savoir ce qu'elle etait (Max, 29/08). */
      var sTitre = document.createElement('p');
      sTitre.className = 'bmk__index-t';
      sTitre.textContent = t('stack_open', 'En savoir plus');
      sommaire.appendChild(sTitre);
      var entrees = [];
      var groupePose = false;
      defs.forEach(function (d, i) {
        if (d.chap === 2 && !groupePose) {
          groupePose = true;
          var g = document.createElement('p');
          g.className = 'bmk__group';
          g.textContent = t('stack_prints', 'Nos tirages');
          sommaire.appendChild(g);
        }
        var it = document.createElement('button');
        it.type = 'button';
        it.className = 'bmk__item' + (d.chap === 2 ? ' bmk__item--sub' : '');
        /* Les fiches sont numerotees : on voit qu'elles se suivent, et
           combien il en reste. */
        if (d.chap === 2) it.innerHTML = '<span class="bmk__item-n">' + deuxChiffres(d.rang + 1) + '</span>';
        it.appendChild(document.createTextNode(d.label));
        it.addEventListener('click', function () { aller(i); });
        sommaire.appendChild(it); entrees.push(it);
      });
      sommaire.appendChild(fleches);

      var pane = document.createElement('div');
      pane.className = 'bmk__pane';

      defs.forEach(function (d) {
        var carte = document.createElement('article');
        carte.className = 'bmk__card bmk__card--' + (d.chap === 2 ? 'fiche' : d.id);
        carte.setAttribute('data-slot', d.id);

        if (d.src) {
          var zoneMedia = document.createElement('div');
          zoneMedia.className = 'bmk__media';
          var m = media(d.src);
          /* `.bm-src-media` existe toujours, meme vide : on cherche ce qui se
             peint, pas la presence du conteneur. */
          if (m && m.querySelector('img, video, svg, iframe')) {
            zoneMedia.appendChild(m.cloneNode(true));
            var ori = orientationDeMedia(zoneMedia);
            if (ori) carte.classList.add('bmk__card--img-' + ori);
          } else {
            carte.classList.add('bmk__card--nomedia');
          }
          carte.appendChild(zoneMedia);
        }

        var corps = document.createElement('div');
        corps.className = 'bmk__body';

        var kicker = document.createElement('p');
        kicker.className = 'bmk__kicker';
        kicker.textContent = d.chap === 2
          ? t('stack_prints', 'Nos tirages') + ' · ' + deuxChiffres(d.rang + 1) + ' / ' + deuxChiffres(fiches.length)
          : d.label;
        corps.appendChild(kicker);

        if (d.id === 'oeuvre') {
          if (tirageSrc) corps.insertAdjacentHTML('beforeend', tirageSrc.innerHTML);
          /* Deux colonnes sur grand ecran : le nom, la ligne d'auteur et la
             note a gauche, les lignes chiffrees a droite. Le HTML du cartel
             reste celui du Liquid — on le range, on ne le reecrit pas. */
          var ct = corps.querySelector('.bmx-cartel');
          if (ct) {
            var gauche = document.createElement('div'); gauche.className = 'bmx-cartel__l';
            var droite = document.createElement('div'); droite.className = 'bmx-cartel__r';
            Array.prototype.slice.call(ct.children).forEach(function (el) {
              (el.classList.contains('bmx-ct-row') ? droite : gauche).appendChild(el);
            });
            ct.appendChild(gauche); ct.appendChild(droite);
          }
        } else if (d.id === 'artiste') {
          corps.insertAdjacentHTML('beforeend', artistSrc.innerHTML);
        } else {
          var h = document.createElement('h2');
          h.className = 'bmk__title';
          h.textContent = d.src.getAttribute('data-title') || d.label;
          corps.appendChild(h);
          var b = body(d.src);
          /* Clone, pas innerHTML : la classe .bm-src-body reste posee, et
             enhanceDims sait retrouver le tableau des dimensions. */
          if (b && b.innerHTML.trim()) corps.appendChild(b.cloneNode(true));
        }

        carte.appendChild(corps);
        pane.appendChild(carte);
      });
      var cartes = Array.prototype.slice.call(pane.querySelectorAll('.bmk__card'));
      stage.appendChild(sommaire);
      stage.appendChild(pane);

      /* ── LES CHOIX, SOUS LA CARTE (Max, 29/08) ──
         « Le bouton ajouter au panier reste, et on peut aussi faire varier
         les choix en toggle. » Ce sont des MIROIRS, pas un second etat :
         chaque pastille CLIQUE le vrai bouton de la colonne d'achat, et
         bisou-variant-ui reste seul maitre du format, du cadre et du prix.
         Aucun libelle n'est ecrit ici — ils sont lus dans le DOM, donc deja
         traduits par Shopify, et les couleurs sont lues sur les vrais
         swatches : une seule verite, un changement de palette suit tout
         seul. */
      var choix = document.createElement('div');
      choix.className = 'bmk__choices';
      var miroirs = [];

      function texteDe(sel, repli) {
        var el = document.querySelector(sel);
        var s = el ? el.textContent.trim() : '';
        return s || repli;
      }

      /* Un groupe = une coque a la hauteur du panier : l'etiquette, LA VALEUR
         COURANTE (au repos), et les options (au survol, a sa place). */
      var valeurs = [];
      function groupeChoix(cle, titre, lireValeur) {
        var g = document.createElement('div');
        g.className = 'bmk__opt';
        g.setAttribute('data-opt', cle);
        var l = document.createElement('span');
        l.className = 'bmk__opt-lbl';
        l.textContent = titre;
        var v = document.createElement('span');
        v.className = 'bmk__opt-now';
        var r = document.createElement('div');
        r.className = 'bmk__opt-row';
        g.appendChild(l); g.appendChild(v); g.appendChild(r);
        choix.appendChild(g);
        valeurs.push({ el: v, lire: lireValeur });
        return r;
      }

      function miroir(rangee, classe, cible, texte, titre) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = classe;
        if (texte) b.textContent = texte;
        if (titre) { b.title = titre; b.setAttribute('aria-label', titre); }
        b.addEventListener('click', function () {
          var vrai = document.querySelector(cible);
          if (vrai) vrai.click();
        });
        rangee.appendChild(b);
        miroirs.push({ el: b, cible: cible });
        return b;
      }

      var vraisFormats = document.querySelectorAll('.rv5-format-row');
      if (vraisFormats.length) {
        var rgFmt = groupeChoix('format', texteDe('#rv5-bloc-fmt-lbl > span', 'Format'), function () {
          var a = document.querySelector('.rv5-format-row.active .rv5-f-paper');
          return a ? a.textContent.trim() : '';
        });
        Array.prototype.forEach.call(vraisFormats, function (r) {
          var f = r.getAttribute('data-f') || '';
          var pap = r.querySelector('.rv5-f-paper');
          var nom = r.querySelector('.rv5-f-name');
          miroir(rgFmt, 'bmk__pill', '.rv5-format-row[data-f="' + f + '"]',
            pap ? pap.textContent.trim() : f, nom ? nom.textContent.trim() : '');
        });
      }

      /* Le swatch « none » EST le sans-cadre (meme geste que dans la colonne :
         il pose withFrame a false). Il devient une pastille de texte, les
         quatre autres des points de couleur. */
      var vraisCadres = document.querySelectorAll('.rv5-color-swatch');
      if (vraisCadres.length) {
        var rgFin = groupeChoix('finition', texteDe('#rv5-bloc-fin-lbl > span', 'Finition'), function () {
          return texteDe('#rv5-color-label', '');
        });
        Array.prototype.forEach.call(vraisCadres, function (sw) {
          var col = sw.getAttribute('data-col') || '';
          var titre = sw.getAttribute('title') || '';
          var cible = '.rv5-color-swatch[data-col="' + col + '"]';
          if (col === 'none') {
            miroir(rgFin, 'bmk__pill bmk__pill--none', cible,
              texteDe('.rv5-btn-sans', titre || 'Sans cadre'), titre);
          } else {
            var d = miroir(rgFin, 'bmk__dot', cible, '', titre);
            var bg = window.getComputedStyle(sw).backgroundColor;
            if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') d.style.backgroundColor = bg;
          }
        });
      }

      /* L'etat allume se lit sur le vrai bouton : `.active`, partout la meme
         classe. Rien a tenir de notre cote. */
      function majChoix() {
        valeurs.forEach(function (v) {
          var s = v.lire();
          if (s && v.el.textContent !== s) v.el.textContent = s;
        });
        miroirs.forEach(function (m) {
          var vrai = document.querySelector(m.cible);
          var on = !!(vrai && vrai.classList.contains('active'));
          m.el.classList.toggle('is-on', on);
          m.el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      /* ── Le pied : le panier, et revenir ── */
      var pied = document.createElement('div');
      pied.className = 'bmk__buy';
      var acheter = document.createElement('button');
      acheter.type = 'button'; acheter.className = 'bmk__atc';
      var acheterL = document.createElement('span'); acheterL.textContent = t('stack_atc', 'Ajouter au panier');
      var acheterP = document.createElement('span'); acheterP.className = 'bmk__atc-price';
      acheter.appendChild(acheterL); acheter.appendChild(acheterP);
      acheter.addEventListener('click', function () {
        var vrai = document.querySelector('.product-form__submit');
        if (vrai) vrai.click();
        /* Refermer rend la colonne d'achat ; le tiroir panier glisse par-dessus. */
        refermer();
      });
      var retour = document.createElement('button');
      retour.type = 'button'; retour.className = 'bmk__back';
      /* « Fermer », pas « Revenir aux choix » : les choix sont dans la rangee,
         il n'y a plus nulle part ou revenir. */
      retour.innerHTML = '<span>' + t('stack_close', 'Fermer') + '</span>' + X;
      retour.addEventListener('click', function () { refermer(); });
      /* Les choix vivent DANS la rangee d'achat, a gauche du bouton (Max,
         29/08 : « alignees avec ajouter au panier »). Sur telephone le CSS
         les masque — la colonne d'achat est entiere juste au-dessus. */
      if (choix.children.length) pied.appendChild(choix);
      pied.appendChild(acheter); pied.appendChild(retour);

      inner.appendChild(tete);
      inner.appendChild(stage);
      inner.appendChild(pied);
      pile.appendChild(inner);
      if (colonne) {
        colonne.classList.add('bmk-host');
        colonne.appendChild(pile);
      } else {
        document.body.appendChild(pile);
      }

      /* ── L'etat ── */
      var actif = -1;
      function chapitreDe(i) { return defs[i] ? defs[i].chap : -1; }
      function premierIndex(chap) {
        for (var i = 0; i < defs.length; i++) if (defs[i].chap === chap) return i;
        return 0;
      }
      function peindre() {
        cartes.forEach(function (c, i) {
          c.classList.toggle('is-on', i === actif);
          c.setAttribute('aria-hidden', i === actif ? 'false' : 'true');
        });
        entrees.forEach(function (it, i) {
          it.classList.toggle('is-on', i === actif);
          it.setAttribute('aria-current', i === actif ? 'true' : 'false');
        });
        chapBtns.forEach(function (b, k) { b.classList.toggle('is-on', CHAPITRES[k].id === chapitreDe(actif)); });
        prec.disabled = actif <= 0;
        suiv.disabled = actif >= cartes.length - 1;
      }

      /* ── Ce qui se regle a l'ouverture et au redimensionnement ──
         La carte a une hauteur decidee par le CSS ; deux choses seulement :
           · le fil d'Ariane (40 px a partir de 1400 px) pousse le bas de la
             colonne sous le pli — on le soustrait, mesure, pas devine ;
           · le cran serre : si un corps ne tient pas dans son volet, il
             perd un corps de texte (.is-dense). Jamais un defilement.
             Au-dela, c'est un texte a raccourcir dans l'editeur. */
      function ajuster() {
        if (!mq.matches) { pile.style.removeProperty('--bmk-crumb'); return; }
        var crumb = document.querySelector('.bisou-pdp-crumb');
        pile.style.setProperty('--bmk-crumb', (crumb && crumb.offsetParent ? crumb.offsetHeight : 0) + 'px');
        /* On mesure LA CARTE, pas son corps : sur ordinateur .bmk__body est
           en `display: contents` — il n'a plus de boite, donc plus de
           hauteur a comparer. La carte, elle, est en overflow hidden. */
        /* Deux crans, mesures l'un apres l'autre : on serre, on re-mesure,
           on serre encore. La carte est en `overflow: hidden`, donc
           scrollHeight dit la verite sur ce qui ne rentre pas. */
        cartes.forEach(function (c) {
          c.classList.remove('is-dense', 'is-tight');
          if (c.scrollHeight > c.clientHeight + 2) {
            c.classList.add('is-dense');
            if (c.scrollHeight > c.clientHeight + 2) c.classList.add('is-tight');
          }
        });
      }

      /* Sur telephone, aller() fait glisser le rail jusqu'a poser la carte
         au centre — c'est le scroll natif, avec son inertie. */
      function centrerMobile(c) {
        if (!c) return;
        var x = c.offsetLeft - (pane.clientWidth - c.offsetWidth) / 2;
        try { pane.scrollTo({ left: Math.max(0, x), behavior: 'smooth' }); } catch (err) { pane.scrollLeft = Math.max(0, x); }
      }
      function aller(i) {
        actif = Math.max(0, Math.min(cartes.length - 1, i));
        peindre();
        if (!mq.matches) centrerMobile(cartes[actif]);
      }
      prec.addEventListener('click', function () { aller(actif - 1); });
      suiv.addEventListener('click', function () { aller(actif + 1); });

      /* Le rail suit le pouce : la carte la plus proche du centre est la
         carte lue, et les chapitres s'allument avec elle. */
      var suiviRail = null;
      pane.addEventListener('scroll', function () {
        if (mq.matches || suiviRail) return;
        suiviRail = requestAnimationFrame(function () {
          suiviRail = null;
          var milieu = pane.scrollLeft + pane.clientWidth / 2;
          var meilleur = actif, ecart = Infinity;
          cartes.forEach(function (c, i) {
            var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - milieu);
            if (d < ecart) { ecart = d; meilleur = i; }
          });
          if (meilleur !== actif) { actif = meilleur; peindre(); }
        });
      }, { passive: true });

      /* Plus de molette captee ici (Max, 03/09) : elle doit faire defiler la
         PAGE, jamais les volets — le changement de fiche reste au clic
         (chapitres, fleches, sommaire). */

      /* ── Le cartel et le prix suivent la variante choisie ── */
      function majCartel() {
        var fmtRow = document.querySelector('.rv5-format-row.active');
        var fmt = fmtRow ? (fmtRow.getAttribute('data-f') || '').toUpperCase() : '';
        var colEl = document.getElementById('rv5-color-label');
        var col = colEl ? colEl.textContent.trim() : '';
        var fEl = pile.querySelector('[data-ct="format"]');
        if (fEl && fmt) {
          var gram = (fmt === 'A4') ? '300 g/m²' : '260 g/m²';
          fEl.textContent = fmt + (col ? ' · ' + col : '') + ' · ' + gram;
        }
        var sEl = pile.querySelector('[data-ct="stock"]');
        var sRow = pile.querySelector('[data-ct-row="stock"]');
        var stockEl = document.getElementById('rv5-stock-text');
        if (sEl && stockEl) {
          var m2 = stockEl.textContent.match(/(\d+)\s*\/\s*(\d+)/);
          if (m2) {
            sEl.textContent = tfill('cartel_stock_value', 'Reste {remaining} / {total} dans ce format', { remaining: m2[1], total: m2[2] });
            if (sRow) sRow.removeAttribute('hidden');
          }
        }
        var priceEl = document.querySelector('.bisou-atc-price');
        var price = priceEl ? priceEl.textContent.trim() : '';
        acheterP.textContent = price;
        acheterP.hidden = !price;
        majChoix();
        /* Le tableau des dimensions vient d'etre reecrit pour ce format :
           le volet peut avoir change de hauteur de texte. */
        if (pile.classList.contains('is-mounted')) ajuster();
      }
      setTimeout(majCartel, 250);
      if (cartelSync) document.removeEventListener('bisou:variant-change', cartelSync);
      cartelSync = majCartel;
      document.addEventListener('bisou:variant-change', cartelSync);

      /* ── Ouvrir, fermer ── */
      function ouvrir(depart) {
        pile.removeAttribute('hidden');
        pile.classList.add('is-mounted');
        actif = -1;
        peindre();
        ajuster();
        if (!mq.matches) pane.scrollLeft = 0;
        requestAnimationFrame(function () {
          pile.classList.add('is-open');
          if (colonne) colonne.classList.add('bmk-on');
          /* Les points de navigation de la page (.bmx-slide-dots, fixes a
             droite) s'effacent tant qu'on lit : ils tombaient sur le module. */
          document.documentElement.classList.add('bmk-open');
          try { fermer.focus({ preventScroll: true }); } catch (err) { fermer.focus(); }
        });
        /* Le premier volet se donne une fois les boutons effaces. */
        setTimeout(function () { if (actif < 0) aller(typeof depart === 'number' ? depart : 0); }, mq.matches ? 240 : 40);
        /* La grille glisse de 50/50 a 30/70 en .6 s : la carte s'elargit
           pendant ce temps, on re-mesure le cran serre une fois posee. */
        setTimeout(ajuster, 720);
        /* Telephone : le module vit dans le flux, la ou etaient les boutons.
           On amene la page dessus, sinon on lit « le centre de la page ». */
        if (!mq.matches) {
          setTimeout(function () {
            var r = pile.getBoundingClientRect();
            var cible = window.scrollY + r.top - 12;
            try { window.scrollTo({ top: Math.max(0, cible), behavior: 'smooth' }); } catch (err) { window.scrollTo(0, Math.max(0, cible)); }
          }, 60);
        }
      }
      function refermer() {
        pile.classList.remove('is-open');
        if (colonne) colonne.classList.remove('bmk-on');
        document.documentElement.classList.remove('bmk-open');
        setTimeout(function () {
          if (pile.classList.contains('is-open')) return;
          pile.classList.remove('is-mounted');
          pile.setAttribute('hidden', '');
        }, 420);
        var l = anchor.querySelector('.bmk-launch');
        if (l) { try { l.focus({ preventScroll: true }); } catch (err) { l.focus(); } }
      }
      fermer.addEventListener('click', refermer);

      function clavier(e) {
        if (!pile.classList.contains('is-open')) return;
        if (e.key === 'Escape') refermer();
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); aller(actif + 1); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); aller(actif - 1); }
      }
      var minuteurTaille = null;
      function retailler() {
        if (!pile.classList.contains('is-open')) return;
        clearTimeout(minuteurTaille);
        minuteurTaille = setTimeout(ajuster, 120);
      }
      document.addEventListener('keydown', clavier);
      window.addEventListener('resize', retailler, { passive: true });

      function detruire() {
        document.removeEventListener('keydown', clavier);
        window.removeEventListener('resize', retailler);
        if (cartelSync === majCartel) { document.removeEventListener('bisou:variant-change', cartelSync); cartelSync = null; }
        if (colonne) colonne.classList.remove('bmk-on');
        document.documentElement.classList.remove('bmk-open');
        if (pile.parentNode) pile.parentNode.removeChild(pile);
      }

      peindre();
      enhanceDims(pane);
      wireCarousels(pane);

      return { ouvrir: ouvrir, detruire: detruire };
    }

    /* Bloc 2 (« Associez le ») : le bouton « mur ». Au clic, ouvre le wall
       planner en DIPTYQUE = produit principal (la page courante) + UNE carte « Associez le »
       VISIBLE à ce moment (la plus centrée dans le carrousel). Desktop uniquement. */
    function buildBloc3Atc() {
      var assoc = document.getElementById('rv5-bloc-associated');
      if (!assoc || assoc.dataset.atcBuilt) return;
      assoc.dataset.atcBuilt = '1';

      var wallHref = '/pages/framed-wall-planner';
      var oldCta = assoc.querySelector('.rv5-wall-cta');
      if (oldCta) {
        var oldLink = oldCta.querySelector('.rv5-wall-btn');
        if (oldLink && oldLink.getAttribute('href')) wallHref = oldLink.getAttribute('href');
        oldCta.style.display = 'none';
      }
      var planBase = wallHref.split('?')[0] || '/pages/framed-wall-planner';

      function handleFromUrl(u) { if (!u) return ''; var m = String(u).match(/\/products\/([^/?#]+)/); return m ? m[1].toLowerCase() : ''; }

      /* la carte associée la plus centrée dans la zone visible du carrousel */
      function pickVisibleAssoc() {
        var grid = assoc.querySelector('.rv5-associated-grid');
        if (!grid) return null;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.rv5-assoc-card'));
        if (!cards.length) return null;
        var gr = grid.getBoundingClientRect();
        var mid = gr.left + gr.width / 2;
        var best = null, bestDist = Infinity;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect();
          if (r.right < gr.left + 4 || r.left > gr.right - 4) return; /* hors zone visible */
          var d = Math.abs((r.left + r.width / 2) - mid);
          if (d < bestDist) { bestDist = d; best = c; }
        });
        return best || cards[0];
      }

      /* le bouton ET la flèche envoient tous deux vers le composer (diptyque) */
      function goToPlanner(e) {
        if (e) e.preventDefault();
        var ids = [];
        var mainH = handleFromUrl(assoc.dataset.productUrl) || handleFromUrl(window.location.pathname);
        if (mainH) ids.push(mainH);
        var card = pickVisibleAssoc();
        var assocH = card && handleFromUrl(card.getAttribute('href'));
        if (assocH && ids.indexOf(assocH) < 0) ids.push(assocH);
        window.location.href = planBase + (ids.length ? '?ids=' + ids.join(',') : '');
      }

      /* UN SEUL OBJET (Max, 28/08 : « pas clair du tout »). Il y avait une
         pilule blanche ET un cercle noir a croix qui la chevauchait — la croix
         disait « ajouter », a cote de vignettes d'achat. Reste une pilule, son
         libelle, une fleche qui dit qu'on part quelque part. Le libelle vient
         de la locale `product.wall_cta`, la meme que le bouton mobile : une
         phrase, un endroit ou la changer. */
      var row = document.createElement('div'); row.className = 'bmx-atc3row';
      var wall = document.createElement('a'); wall.className = 'bmx-wall3'; wall.href = planBase;
      var libelle = document.createElement('span'); libelle.textContent = t('wall_cta', 'Voir sur votre mur');
      wall.appendChild(libelle);
      wall.insertAdjacentHTML('beforeend', A_R);
      wall.addEventListener('click', goToPlanner);
      row.appendChild(wall);

      if (oldCta && oldCta.parentNode) { oldCta.parentNode.insertBefore(row, oldCta); }
      else { assoc.appendChild(row); }
    }

    function build() {
      var next = mq.matches ? 'd' : 'm';
      if (next === mode) return;
      mode = next;
      anchor.innerHTML = ''; mount.innerHTML = '';
      document.querySelectorAll('.bmx-sheet, .bmx-tin, .bmk').forEach(function (n) { n.remove(); });
      /* reset bloc 2 : retire la rangée ATC injectée et restaure la CTA mur d'origine */
      var assoc = document.getElementById('rv5-bloc-associated');
      if (assoc) {
        assoc.removeAttribute('data-atc-built');
        var injected = assoc.querySelector('.bmx-atc3row'); if (injected) injected.remove();
        var origCta = assoc.querySelector('.rv5-wall-cta'); if (origCta) origCta.style.display = '';
      }
      document.documentElement.classList.remove('bmx-detail-open', 'bmx-slides');
      document.documentElement.style.removeProperty('overflow');

      /* Le module precedent part avec ses ecouteurs et ses classes d'etat :
         une colonne sans module derriere ne doit jamais rester effacee. */
      if (moduleCourant) { moduleCourant.detruire(); moduleCourant = null; }
      moduleCourant = buildPostale();
      ouvrirCourant = moduleCourant.ouvrir;

      /* Le declencheur : petit a droite du panier sur ordinateur, pleine
         largeur sous lui sur telephone. Un seul canon — contour noir. */
      var lanceur = document.createElement('button');
      lanceur.type = 'button';
      lanceur.className = 'bmk-launch';
      var label = t('stack_open', 'En savoir plus');
      if (next === 'm') label = section.getAttribute('data-mbtn-label') || label;
      /* Un point qui pulse a gauche du libelle, comme l'ancien bouton mobile
         (Max, 28/08) : un signe de vie, pas une fleche. */
      lanceur.innerHTML = '<span class="bmx-pulse" aria-hidden="true"></span><span>' + label + '</span>';
      lanceur.addEventListener('click', function () { if (ouvrirCourant) ouvrirCourant(0); });
      anchor.appendChild(lanceur);

      if (next === 'd') {
        buildBloc3Atc();
        document.documentElement.classList.add('bmx-slides');
      }
    }

    installDesktopMagneticScroll();
    build();

    /* « + d'infos » (repère sous la rangée d'achat) : visible en haut,
       s'efface au défilement. Le clic ouvre le volet sur le cartel. */
    (function setupScrollCue() {
      var link = document.querySelector('.rv5-more-link');
      if (!link) return;
      function upd() { link.classList.toggle('is-hidden', window.scrollY > window.innerHeight * 0.5); }
      upd();
      window.addEventListener('scroll', upd, { passive: true });
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (ouvrirCourant) ouvrirCourant(0);
      });
    })();

    /* ── Pourquoi ce nom, et pas « t » ──
       « var t » vivait ici, dans la portee de init(). Le pont i18n ajoute plus
       tard a declare un helper t(cle, repli) au niveau du module. Par hoisting,
       tous les t(...) ecrits DANS init() ne visaient plus le helper mais ce
       chronometre, encore undefined : « t is not a function », et le volet
       mourait a sa premiere ligne. C'est le cartel disparu d'aout.
       Le chronometre porte desormais un nom a lui. Ne pas le rappeler « t ». */
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(build, 180); });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
